import { render, staticRenderFns } from "./IntegrationsNote.vue?vue&type=template&id=d0a268b2"
import script from "./IntegrationsNote.vue?vue&type=script&lang=js"
export * from "./IntegrationsNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports